import { Image, Input } from "@nextui-org/react";
import React, { useState, useEffect } from "react";
import joinUs from "../../Assets/landing/join-us.svg";
import * as Yup from "yup";
import axios from "axios";
import { useFormik } from "formik";
import CommunityModal from "components/SuccessModals/CommunityModal";

const JoinFrond = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [communityModal, setCommunityModal] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  async function callSubscriber(reqBody) {
    setIsLoading(true);
    setIsDisabled(true);
    setErrorMessage("");
    try {
      const { data } = await axios.post(
        `/newsletter-subscribe`,
        reqBody
      );

      if (data?.status === 201) {
        setCommunityModal(true);
        communityForm.handleReset();
      }
    } catch (error) {
      if (
        error?.response?.data?.message === "The email has already been taken."
      ) {
        setErrorMessage(
          "This email address is already subscribed to our mailing list"
        );
      } else {
        setErrorMessage(error?.response?.data?.message || "An error occurred");
      }
    }
    setIsLoading(false);
    setIsDisabled(false);
  }

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email").required("Email required"),
  });

  const communityForm = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: callSubscriber,
  });

  return (
    <>
      <section className="join-us py-20 md:py-20 lg:py-24 relative overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-gradient-to-r from-purple-100 to-pink-100 rounded-full blur-3xl opacity-50 animate-pulse"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full blur-3xl opacity-50 animate-pulse delay-1000"></div>
        </div>

        <div className="container xl:px-44 px-6 mx-auto relative z-10">
          <div className={`flex gap-x-12 gap-y-12 justify-between items-center lg:flex-nowrap flex-wrap transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            
            {/* Left Side - Content */}
            <div className="content flex-1">
             
              {/* Main Heading - No Wrap */}
              <h2 className="text-4xl md:text-5xl lg:text-5xl font-bold mb-4 whitespace-nowrap">
                <span className="bg-gradient-to-r from-pink-600 via-orange-600 to-pink-600 bg-clip-text text-transparent">
                  Join the frond Community
                </span>
              </h2>
              
              {/* Description */}
              <p className="text-gray-600 text-lg md:text-xl mb-8 leading-relaxed">
                Connect with the frond team for news, updates, and exclusive insights. 
                Be the first to know about new features and community events.
              </p>
        
              {/* Subscription Form */}
              <form onSubmit={communityForm.handleSubmit} className="mt-8">
                <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                  <div className="flex-1 w-full sm:w-auto relative group">
                    <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-0 group-hover:opacity-30 transition duration-500"></div>
                    <Input
                      name="email"
                      type="email"
                      placeholder="Enter your email address"
                      classNames={{
                        input: "border-none text-base py-2",
                        inputWrapper: "min-h-[52px] border-2 border-gray-200 bg-white rounded-xl hover:border-purple-300 focus-within:border-purple-500 transition-all duration-300",
                        mainWrapper: "w-full",
                        base: "w-full sm:w-[320px] md:w-[386px]",
                      }}
                      onChange={communityForm.handleChange}
                      onBlur={communityForm.handleBlur}
                      value={communityForm.values.email}
                      isInvalid={communityForm.errors.email && communityForm.touched.email}
                      errorMessage={
                        communityForm.errors.email && communityForm.touched.email
                          ? communityForm.errors.email
                          : null
                      }
                    />
                  </div>
                  <button
                    disabled={
                      !(communityForm.isValid && communityForm.dirty) || isDisabled
                    }
                    type="submit"
                    className="group relative inline-flex items-center justify-center gap-2 bg-gradient-to-r from-pink-600 via-pink-600 to-orange-600 rounded-xl px-8 py-3 font-bold text-white transition-all duration-300 hover:scale-105 hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 overflow-hidden whitespace-nowrap"
                  >
                    <span className="absolute inset-0 bg-gradient-to-r from-purple-700 via-pink-700 to-orange-700 transform -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></span>
                    <span className="relative flex items-center gap-2 whitespace-nowrap">
                      {isLoading ? (
                        <>
                          <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          <span>Subscribing...</span>
                        </>
                      ) : (
                        <>
                          Let's Connect
                          <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                          </svg>
                        </>
                      )}
                    </span>
                  </button>
                </div>
                
                {errorMessage && (
                  <div className="mt-4 p-3 bg-red-50 border-l-4 border-red-500 rounded-lg animate-shake">
                    <p className="text-red-600 text-sm">{errorMessage}</p>
                  </div>
                )}
                
                {/* Privacy note */}
                <p className="text-gray-400 text-xs mt-4">
                  We respect your privacy. Unsubscribe at any time.
                </p>
              </form>
            </div>

            {/* Right Side - Image with animations */}
            <div className="join-img flex-1 flex justify-center lg:justify-end">
              <div className="relative">
                {/* Image container with float animation */}
                <div className="relative animate-float">
                  <div className="relative rounded-2xl overflow-hidden">
                    <Image
                      src={joinUs}
                      alt="Join Us"
                      className="w-full h-auto object-cover"
                    />
                    {/* Overlay effect */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  </div>
                  
                  {/* Decorative elements */}
                  <div className="absolute -top-4 -right-4 w-20 h-20 border border-purple-300 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500"></div>
                  <div className="absolute -bottom-4 -left-4 w-16 h-16 border border-pink-300 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-500 delay-150"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CommunityModal
        isOpen={communityModal}
        onClose={() => {
          setCommunityModal(false);
        }}
      />

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .animate-shimmer {
          animation: shimmer 2s ease-in-out infinite;
        }
        
        .animate-shake {
          animation: shake 0.3s ease-in-out;
        }
        
        .delay-1000 {
          animation-delay: 1s;
        }
      `}</style>
    </>
  );
};

export default JoinFrond;